import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

const useAuth = () => {
  const token = useSelector((state: RootState) => state.auth.accessToken);
  const isRefreshing = useSelector((state: RootState) => state.auth.isRefreshing);
  // Última renovação falhou por rede/timeout/5xx (at-22): a sessão NÃO morreu.
  const sessaoIndisponivel = useSelector((state: RootState) => state.auth.sessaoIndisponivel);

  return { token, isRefreshing, sessaoIndisponivel };
};

export default useAuth;
